export default "__VITE_ASSET__87e84741__"